import { render, staticRenderFns } from "./FooterLanding.vue?vue&type=template&id=26a806d9&scoped=true&"
import script from "./FooterLanding.vue?vue&type=script&lang=js&"
export * from "./FooterLanding.vue?vue&type=script&lang=js&"
import style0 from "./FooterLanding.vue?vue&type=style&index=0&id=26a806d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a806d9",
  null
  
)

export default component.exports